// test2782
(2782 && 0);
